function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-1044-566H876v2651h-1920z"
}), React.createElement("path", {
  d: "M-1045-259H875v2286h-1920z"
}), React.createElement("g", {
  transform: "translate(-69.5 -52)"
}, React.createElement("path", {
  d: "M106.094 61.053c15.101 0 27.344 12.243 27.344 27.344 0 15.102-12.243 27.344-27.344 27.344-15.102 0-27.344-12.242-27.344-27.344 0-15.101 12.242-27.344 27.344-27.344zm0 2.188c-13.894 0-25.156 11.263-25.156 25.156 0 13.894 11.262 25.156 25.156 25.156 13.893 0 25.156-11.262 25.156-25.156 0-13.893-11.263-25.156-25.156-25.156zm-5.271 26.452c2.675 0 4.354 1.315 5.603 2.624l.478.52.967 1.095c1.125 1.242 2.193 2.155 4.077 2.155s2.855-.769 4.038-2.097l1.065-1.23c1.281-1.447 2.841-2.865 5.449-3.047l-.003 2.564c-1.644.157-2.548 1.01-3.727 2.372l-.773.9-.496.547c-1.279 1.353-2.878 2.548-5.553 2.548-2.854 0-4.574-1.496-5.848-2.885l-1.2-1.354c-1.125-1.242-2.193-2.154-4.077-2.154-1.74 0-2.7.654-3.769 1.8l-.547.613-.789.915c-1.287 1.453-2.854 2.876-5.48 3.048a.534.534 0 0 1-.55-.534l.001-2.006c1.893 0 2.865-.769 4.047-2.097l1.282-1.476.512-.54c1.236-1.24 2.796-2.28 5.293-2.28zm0-10.23c2.497 0 4.126 1.146 5.348 2.363l.5.522 1.2 1.354c1.125 1.243 2.193 2.155 4.077 2.155s2.855-.768 4.038-2.097l1.065-1.23c1.281-1.447 2.841-2.865 5.449-3.047l-.003 2.564c-1.644.157-2.548 1.01-3.727 2.372l-.773.9c-1.367 1.56-3.017 3.095-6.05 3.095-2.853 0-4.573-1.496-5.847-2.885l-1.2-1.354c-1.125-1.242-2.193-2.154-4.077-2.154s-2.856.768-4.038 2.097l-1.067 1.232c-1.287 1.452-2.854 2.875-5.48 3.047a.535.535 0 0 1-.55-.52v-.015l.001-2.005c1.893 0 2.865-.768 4.047-2.097l1.282-1.476c1.322-1.46 2.951-2.82 5.805-2.82z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-69.5 -56.72)"
}, React.createElement("tspan", {
  x: 69.416,
  y: 138.719
}, "Zalewanie")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 71,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/flooding.d3a2b292.svg";
export { SvgComponent as ReactComponent };